import React, { useState, useEffect } from 'react';
import './NewsFeed.css';

// Placeholder image path (relative to public folder)
const placeholderImagePath = '/images/news-placeholder.svg';

export const NewsFeed = ({ representativeName }) => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsFromBackend = async () => {
      if (!representativeName) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      setNewsItems([]); 

      try {
        const backendUrl = `${window.apiUrl}/newsfeed?representativeName=${encodeURIComponent(representativeName)}`;
        
        const response = await fetch(backendUrl, {
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY_1, 
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
           let errorMsg = `Failed to fetch news from backend. Status: ${response.status}`;
           try {
               const errorData = await response.json();
               errorMsg = errorData.message || errorData.error || errorMsg;
           } catch (parseError) { /* Ignore */ }
           throw new Error(errorMsg);
        }

        const data = await response.json();
        
        if (Array.isArray(data)) {
            setNewsItems(data);
        } else {
            console.warn("Received non-array data from newsfeed endpoint:", data);
            setNewsItems([]); 
        }

      } catch (err) {
        setError(err.message || 'Failed to fetch news. Please try again later.');
        console.error("News fetch error (backend):", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsFromBackend();
  }, [representativeName]); 

  return (
    <div className="news-feed-container"> {/* Changed class name */}
      {loading && <div className="loading-news">Loading news...</div>}
      {error && <div className="error-news">{error}</div>}
      {!loading && !error && (
        <ul className="news-feed-list">
          {newsItems.length > 0 ? (
            newsItems.map(item => (
              <li key={item.id} className="news-feed-item"> 
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="news-link-wrapper">
                  {/* Use actual image or SVG placeholder */}
                  <img
                    src={item.image || placeholderImagePath}
                    alt="" // Alt text could be improved if title is reliable
                    className={`news-image ${!item.image ? 'is-placeholder' : ''}`} // Add class for placeholder styling if needed
                    onError={(e) => {
                      // If the primary image fails, try the placeholder. If placeholder fails, hide.
                      if (e.target.src !== placeholderImagePath) {
                        e.target.src = placeholderImagePath;
                      } else {
                        e.target.style.display = 'none'; // Hide if even placeholder fails
                      }
                    }}
                  />
                  <div className="news-content">
                    {/* Only show site name if it exists */}
                    {item.siteName && <span className="news-site-name">{item.siteName}</span>}
                    <h3 className="news-title">{item.title}</h3>
                    {item.description && <p className="news-description">{item.description}</p>}
                    {/* Optional: Display pubDate */}
                    {/* {item.pubDate && <span className="news-pubdate">{new Date(item.pubDate).toLocaleDateString()}</span>} */}
                  </div>
                </a>
              </li>
            ))
          ) : (
            <li className="no-news-message">No recent news found for this representative.</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default NewsFeed;
